import { useState } from 'react';
import { LinkApplePayRequest, LinkApplePayResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useLinkApplePay() {
  const [linking, setLinking] = useState(false);

  async function linkApplePay(requestParams: LinkApplePayRequest): Promise<LinkApplePayResponse> {
    try {
      setLinking(true);
      const res = await api.linkApplePay(requestParams);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setLinking(false);
    }
  }

  return {
    linking,
    linkApplePay,
  };
}
